<template>
    <div :class="wrapper">
        <input
            v-if="searchable"
            ref="search"
            v-model="search"
            :placeholder="$t('Search')"
            class="form-input w-full mb-2 rounded-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
        <div
            ref="main"
            :style="'max-height:' + listHeight + 'px;'"
            class="overflow-y-auto overflow-x-hidden"
            :class="{ 'pr-2': overflowed }"
        >
            <div v-show="filteredOptions.length == 0" class="flex items-center space-x-3 text-gray-500 text-sm">
                {{ $t('No results found') }}
            </div>
            <div v-show="filteredOptions.length > 0" class="grid grid-cols-1 xl:grid-cols-2 gap-2">
                <router-link v-for="(item, index) in filteredOptions"
                    :key="item.id"
                    :is="router ? 'router-link' : 'div'"
                    :to="router ? '/dashboard/admin/' + type + '/' + item.id + '/edit' : null"
                    class="flex items-center col-span-1 space-x-3 py-1 px-3 rounded-sm bg-gray-300 hover:bg-gray-400"
                    :class="{ 'bg-green-200 hover:bg-green-300': item.status, 'bg-red-200 hover:bg-red-300': !item.status, 'py-3': detailed }"
                >
                    <template v-if="!detailed">
                        <div class="flex-shrink-0 inline-block">
                            <img :src="item.avatar" alt="Icon" class="w-5 h-auto rounded-full object-scale-down">
                        </div>
                        <div class="text-sm leading-6 font-normal block truncate">
                            {{ item.name }}
                        </div>
                    </template>
                    <template v-else>
                        <!--<template v-if="type === 'servers'">

                        </template>
                        <template v-else-if="type === 'orgs'">
                            <div class="flex items-center gap-5 truncate">
                                <div class="flex-shrink-0">
                                    <img :alt="$t('Avatar')" :src="item.avatar" class="block m-auto h-16 w-16 object-scale-down">
                                    <support-code
                                        :orgCode="item.support_code"
                                        :isLocal="item.id_ext == null"
                                        onlyOrg
                                        small
                                        wrapper="w-20 mt-3"
                                    >
                                    </support-code>
                                </div>
                                <div class="min-w-0 flex-1">
                                    <div class="text-sm leading-5 font-medium text-blue-600 truncate">
                                        <span>{{ item.name }}</span>
                                        <span class="font-normal text-blue-500">
                                            <span v-for="(phone, index) in item.phones">
                                                <span v-if="index == 0" class="mx-1">/</span>
                                                <span>{{ phone.country_code == "34" ? phone.number : "+" + phone.country_code + phone.number }}</span>
                                                <span v-if="index + 1 < item.phones.length" class="mx-1">/</span>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="mt-2 flex items-center text-xs leading-4 text-gray-600">
                                        <div v-for="(email, index) in item.emails" class="flex items-center truncate">
                                            <svg-vue :class="{ 'ml-3' : index > 0 }" class="flex-shrink-0 mr-1.5 h-3.5 w-3.5 text-gray-700" icon="font-awesome.envelope-solid"></svg-vue>
                                            <span class="truncate">
                                                <span class="font-bold">
                                                    {{ email.environment.substring(0, 3).toUpperCase() }}
                                                </span>
                                                {{ ' ' + email.name + '@' + email.domain }}
                                            </span>
                                        </div>
                                        <div v-if="item.emails.length == 0" class="flex items-center truncate">
                                            <svg-vue class="flex-shrink-0 mr-1.5 h-3.5 w-3.5 text-gray-700" icon="font-awesome.envelope-solid"></svg-vue>
                                            <span class="truncate">-</span>
                                        </div>
                                    </div>
                                    <div class="mt-2 flex items-center text-xs leading-4 text-gray-600">
                                        <svg-vue class="flex-shrink-0 mr-1.5 h-3.5 w-3.5 text-gray-700" icon="font-awesome.server-solid"></svg-vue>
                                        <span class="truncate">{{ item.server?.name ?? "-" }}</span>
                                    </div>
                                    <div class="mt-2 flex items-center text-xs leading-4 text-gray-600">
                                        <svg-vue class="flex-shrink-0 mr-1.5 h-3.5 w-3.5 text-gray-700" icon="font-awesome.language-regular"></svg-vue>
                                        <span class="truncate">{{ item.language?.name ?? "-" }}</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="type === 'centers'">

                        </template>
                        <template v-else-if="type === 'users'">
                            <div class="flex items-center gap-6">
                                <div class="flex-shrink-0">
                                    <img :alt="$t('Avatar')" :src="item.avatar" class="block m-auto h-24 w-24 object-scale-down">
                                    <support-code
                                        :orgCode="item.centers[0]?.organization?.support_code"
                                        :userSupport="item.support"
                                        :userCode="item.support_code"
                                        :isLocal="item.id_ext == null"
                                        :isAdmin="item.role_id == 1"
                                        wrapper="w-28 mt-3"
                                    >
                                    </support-code>
                                </div>
                                <div class="min-w-0 flex-1">
                                    <div class="flex items-center text-base leading-5 font-medium text-blue-600 truncate">
                                        <span>{{ item.name }}</span>
                                        <span class="ml-2.5 truncate font-normal text-blue-500">
                                            <span v-for="(phone, index) in item.phones">
                                                <span v-if="index == 0" class="mr-1">/</span>
                                                <span>{{ phone.country_code == "34" ? phone.number : "+" + phone.country_code + phone.number }}</span>
                                                <span v-if="index + 1 < item.phones.length" class="mx-1">/</span>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="mt-2 flex items-center text-sm leading-5 text-gray-600">
                                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-500" icon="font-awesome.envelope-solid"></svg-vue>
                                        <span class="truncate">{{ item.email ? item.email : "-" }}</span>
                                    </div>
                                    <div v-if="item.centers.length > 0" class="flex items-center mt-2 text-sm leading-5 text-gray-500 truncate">
                                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-500" icon="font-awesome.building-regular"></svg-vue>
                                        <span class="truncate">{{ item.centers[0].organization ? item.centers[0].organization.name : '-' }}</span>
                                    </div>
                                    <div v-else class="flex items-center mt-2 text-sm leading-5 text-gray-500 truncate">
                                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-500" icon="font-awesome.building-regular"></svg-vue>
                                        <span class="truncate">-</span>
                                    </div>
                                    <div v-for="(center, index) in item.centers" class="flex items-center mt-2 text-sm leading-5 text-gray-500 truncate">
                                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-500" icon="font-awesome.hospital-regular"></svg-vue>
                                        <span class="truncate">{{ center.name }}</span>
                                    </div>
                                    <div v-if="item.centers.length == 0" class="flex items-center mt-2 text-sm leading-5 text-gray-500 truncate">
                                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-500" icon="font-awesome.hospital-regular"></svg-vue>
                                        <span class="truncate">-</span>
                                    </div>
                                    <div v-if="item.profile" class="mt-2 flex items-center text-sm leading-5 text-gray-500">
                                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-500" icon="font-awesome.id-badge-regular"></svg-vue>
                                        <span class="truncate">{{ item.profile.name }}</span>
                                    </div>
                                    <div v-else class="mt-2 flex items-center text-sm leading-5 text-gray-500">
                                        <svg-vue class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-500" icon="font-awesome.id-badge-regular"></svg-vue>
                                        <span class="truncate">-</span>
                                    </div>
                                </div>
                            </div>
                        </template>-->
                    </template>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "list-view",
    props: {
        type : {
            type: String,
            required: true,
            validator: (value) => {
                return ['servers', 'orgs', 'centers', 'users'].includes(value);
            }
        },
        list: {
            type: Array,
            required: true,
            default: []
        },
        wrapper: {
            type: String,
            default: ''
        },
        listHeight: {
            type: Number,
            default: 320
        },
        detailed: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: false
        },
        router: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        filteredOptions() {
            const self = this;
            return self.list.filter(item => {
                if (self.search && self.searchable) {
                    return item.name.toLowerCase().includes(self.search.toLowerCase());
                }
                return true;
            });
        }
    },
    data() {
        return {
            search: null,
            overflowed: false,
            resizeObserver: null
        }
    },
    mounted() {
        this.resizeManager('observe');
    },
    beforeDestroy() {
        this.resizeManager('unobserve');
    },
    methods: {
        resizeManager(mode) {
            const self = this;
            if (mode === 'observe') {
                self.resizeObserver = new ResizeObserver(self.checkOverflow);
                self.resizeObserver.observe(self.$refs.main);
                self.checkOverflow();
            } else if (mode === 'unobserve') {
                self.resizeObserver.unobserve(self.$refs.main);
            }
        },
        checkOverflow() {
            this.overflowed =  this.$refs.main.scrollHeight > this.$refs.main.clientHeight;
        }
    }
}
</script>
